module.exports = __webpack_public_path__ + "static/media/huangshengyi.beca9ae1.png";